module.exports = __webpack_public_path__ + "ssygl/img/xm2.ec01bd4a.jpg";